import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { makeHeadData } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { adverTableData } from 'lib/api/media';

import BasicTable from 'components/molecules/MbBasicTable';
import SnackbarWrap from 'components/organisms/Snackbar/SnackbarWrap';

const useStyles = makeStyles((theme) => ({
  title: {
    flex: '0 0 auto',
    marginBottom: 10,
  },
}));

const MediaAdverTable = ({ params }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const tableHead = {
    headList: [
      {
        id: 'CODE_DESC',
        label: t('구분'),
        orderFlag: false,
        type: 'string',
        format: '@',
      },
      {
        id: 'BANNER_CNT',
        label: t('배너'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'BRAND_CNT',
        label: t('브랜드커버'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'ICOVER_CNT',
        label: t('아이커버'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
      {
        id: 'NATIVE_CNT',
        label: t('네이티브'),
        orderFlag: false,
        type: 'number',
        format: '#,##0',
      },
    ],
    sort: 'desc',
    order: 'STATS_DTTM',
  };
  const initTableList = [];
  const [tableList, setTableList] = useState(initTableList);
  const initLoading = {
    table: true,
  };
  const [loading, setLoading] = useState(initLoading);

  const initSnackbar = {
    open: false,
    variant: '',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, [params]);

  const getData = () => {
    setLoading(initLoading);
    setTableList(initTableList);
    adverTableData({ ...paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        setTableList(data);
      })
      .catch((error) => {
        setSnackbar({
          ...snackbar,
          open: true,
          variant: 'error',
          message: error,
        });
      })
      .finally(() => {
        setLoading({
          ...loading,
          table: false,
        });
      });
  };

  /**
   * 스낵바 닫는 함수
   * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
   * @param event
   * @param reason
   */
  const handleSnackBarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({
      ...snackbar,
      open: false,
      message: '',
    });
  };

  return (
    <>
      <div className={classes.title}>
        <Typography variant="h6">
          {t('광고주 정보')}
          <span style={{ fontSize: 13 }}>
            ({moment().format('YYYY-MM-01')} ~ {moment().format('YYYY-MM-DD')})
          </span>
        </Typography>
      </div>
      <BasicTable
        sort={tableHead.sort}
        order={tableHead.order}
        list={tableList}
        headCells={makeHeadData(tableHead.headList)}
        loading={loading.table}
      />
      <SnackbarWrap
        open={snackbar.open}
        variant={snackbar.variant}
        message={snackbar.message}
        onClose={handleSnackBarClose}
      />
    </>
  );
};

export default MediaAdverTable;
